import {
  selectFromCompletedRoutesInsightsDriverBreakdownOvertimePaginatedDto,
  InsightsDriverBreakdownOvertimeDtoModelSelector, InsightsOverTimeBinDtoModelSelector,
} from '../../models';
import { completedOrdersFragment } from './fragments/completedOrdersFragment';
import { completedRoutesFragment } from './fragments/completedRoutesFragment';
import { completedWorkingTimeFragment } from './fragments/completedWorkingTimeFragment';
import { deliveredOrdersFragment } from './fragments/deliveredOrdersFragment';
import { estimatedDistanceCompletedFragment } from './fragments/estimatedDistanceCompletedFragment';
import { missedOrdersFragment } from './fragments/missedOrdersFragment';

export interface DriverBreakdownOverTimeFragments {
  completedOrders?: boolean;
  completedWorkingTime?: boolean;
  estimatedDistanceCompleted?: boolean;
  completedRoutes?: boolean;
  deliveredOrders?: boolean;
  missedOrders?: boolean;
}

export const CompletedRoutesInsightsDriverBreakdownOvertimePaginatedQuery = (includeFragments: DriverBreakdownOverTimeFragments = {}) => {
  const baseSelector = selectFromCompletedRoutesInsightsDriverBreakdownOvertimePaginatedDto();

  const buildNodeSelector = (
    nodeSelector: InsightsDriverBreakdownOvertimeDtoModelSelector,
  ): InsightsDriverBreakdownOvertimeDtoModelSelector => {
    if (includeFragments.completedOrders ?? false) {
      nodeSelector = nodeSelector?.completedOrders((c: InsightsOverTimeBinDtoModelSelector) => completedOrdersFragment(c));
    }
    if (includeFragments.completedWorkingTime ?? false) {
      nodeSelector = nodeSelector.completedWorkingTime((c: InsightsOverTimeBinDtoModelSelector) => completedWorkingTimeFragment(c));
    }
    if (includeFragments.estimatedDistanceCompleted ?? false) {
      nodeSelector = nodeSelector.estimatedDistanceCompleted((c: InsightsOverTimeBinDtoModelSelector) => estimatedDistanceCompletedFragment(c));
    }
    if (includeFragments.completedRoutes ?? false) {
      nodeSelector = nodeSelector.completedRoutes((c: InsightsOverTimeBinDtoModelSelector) => completedRoutesFragment(c));
    }
    if (includeFragments.deliveredOrders ?? false) {
      nodeSelector = nodeSelector.deliveredOrders((c: InsightsOverTimeBinDtoModelSelector) => deliveredOrdersFragment(c));
    }
    if (includeFragments.missedOrders ?? false) {
      nodeSelector = nodeSelector.missedOrders((c: InsightsOverTimeBinDtoModelSelector) => missedOrdersFragment(c));
    }
    return nodeSelector;
  };

  let selectorBuilder = baseSelector.edges((e) =>
    e.node((n) => buildNodeSelector(n
      .driverId
      .driverName
      .deleted)),
  );

  return selectorBuilder.toString();
};
